var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1150,
    height: 896,
    viewBox: "0 0 1150 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_497_4974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.569 744.03C697.317 729.971 703.12 716.175 706.549 701.851C717.539 656.333 712.527 611.782 696.789 568.109C683.689 531.818 663.291 500.008 638.672 470.482C614.142 441.045 586.27 414.859 559.102 387.97C531.934 361.081 505.205 333.664 482.521 302.821C463.002 276.284 446.825 247.901 440.142 215.388C425.196 143.244 445.506 81.821 501.864 34.5455C539.847 2.5598 584.512 -8.68792 632.781 7.04131C674.281 20.5737 702.24 48.5173 712.264 92.1022C715.868 107.831 715.165 123.561 709.011 138.675C708.219 140.696 707.428 142.893 706.109 144.562C701.185 150.538 701.449 157.216 702.592 164.158C703.999 172.769 706.285 181.469 703.911 190.256C702.768 194.562 700.834 198.78 698.46 202.47C695.998 206.249 693.184 205.458 691.514 201.24C685.799 186.478 680.172 171.803 674.281 157.128C673.578 155.458 671.643 153.877 669.885 153.174C662.851 150.362 655.553 148.253 648.52 145.353C639.288 141.575 632.869 134.72 628.737 125.67C626.715 121.276 624.868 116.794 622.934 112.401C614.757 94.5626 599.547 86.3904 580.116 89.3781C557.08 92.893 540.111 105.547 528.505 125.23C514.877 148.253 511.536 173.297 516.547 199.395C522.35 229.711 537.561 255.37 556.464 279.095C576.687 304.491 600.338 326.722 623.813 348.954C650.718 374.437 678.15 399.393 701.01 428.831C731.695 468.286 751.741 512.486 756.137 562.573C761.325 621.36 746.29 674.874 710.417 722.15C705.054 729.268 698.987 735.858 693.184 742.624C692.833 743.064 692.393 743.327 691.953 743.679C692.041 743.855 692.305 743.942 692.569 744.03Z",
    fill: "url(#paint0_linear_497_4974)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_497_4974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.972 825.022C571.5 822.266 572.115 819.421 572.643 816.664C576.599 794.527 588.381 776.834 602.8 760.387C608.779 753.63 614.582 746.784 619.593 739.316C628.562 725.891 630.32 702.385 625.308 687.095C621.528 675.495 621.616 664.424 627.946 653.703C631.375 647.816 636.475 643.861 642.102 640.258C646.85 637.183 651.246 633.668 656.345 630.065C649.575 631.295 643.772 633.404 637.969 633.229C620.824 632.701 607.284 616.972 608.427 599.749C609.57 581.735 625.308 567.5 642.805 568.554C662.939 569.785 677.095 588.238 673.402 608.185C673.138 609.679 673.666 611.963 674.721 613.018C698.548 636.919 705.846 665.917 701.01 698.518C695.295 737.446 674.809 767.762 645.179 792.63C634.628 801.505 624.077 810.38 613.615 819.255C593.744 836.039 580.116 857.041 572.379 881.821C571.939 883.315 571.412 884.808 570.62 887.181C569.917 885.599 569.389 884.633 569.038 883.666C559.278 852.911 541.166 828.394 515.229 809.15C490.786 790.872 469.421 769.431 454.035 742.718C442.781 723.21 434.604 702.56 435.043 679.625C435.483 654.142 445.506 633.141 465.992 617.499C466.608 617.06 467.047 616.533 467.575 616.093C458.167 594.916 461.948 576.99 478.038 566.182C491.666 557.043 509.954 558.976 521.471 570.839C533.429 583.053 535.1 601.946 525.34 615.566C514.438 630.856 497.644 634.371 477.95 625.935C479.005 626.902 479.884 628.132 481.027 628.923C486.126 632.35 491.138 635.953 496.413 639.116C513.822 649.397 520.768 665.302 515.141 684.634C508.986 705.899 513.734 733.448 529.912 747.762C550.926 766.343 560.07 790.793 567.807 816.398C568.686 819.332 569.302 822.266 570.093 825.2C570.357 825.022 570.62 825.022 570.972 825.022Z",
    fill: "url(#paint1_linear_497_4974)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.095 335.688C327.425 343.684 332.877 351.856 339.647 358.886C354.769 374.615 370.42 389.817 385.982 405.107C403.215 421.979 419.92 439.289 431.526 460.555C437.769 471.89 442.077 484.28 447.352 496.143C448.407 498.428 447.968 500.01 445.77 501.679C427.57 515.387 415.348 533.665 406.82 554.403C384.487 608.533 388.356 662.135 410.864 715.21C420.272 737.354 433.109 757.389 449.287 775.227C449.638 775.579 449.902 776.106 449.726 777.073C440.143 770.482 430.559 763.979 421.063 757.213C390.906 735.597 363.298 711.168 341.405 681.028C300.345 624.438 277.485 561.521 278.804 491.047C279.595 443.507 291.553 398.517 311.687 355.547C314.765 348.956 317.93 342.454 321.095 335.688Z",
    fill: "url(#paint2_linear_497_4974)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 669.959C102.343 663.457 120.983 661.436 139.974 664.248C162.834 667.675 184.463 674.441 203.894 687.182C205.389 688.149 206.883 689.203 207.938 690.521C252.076 745.003 308.17 782.436 373.673 806.074C400.05 815.564 426.954 823.824 453.595 832.7C476.631 840.432 498.787 849.923 518.394 864.422C524.988 869.343 530.967 875.23 537.21 880.678C536.946 881.03 536.682 881.469 536.418 881.82C535.891 881.82 535.363 881.908 534.924 881.645C523.582 876.812 512.239 877.251 500.546 880.59C468.542 889.817 436.01 895.001 402.512 892.892C358.111 890.081 316.259 878.306 277.134 857.216C228.952 831.206 188.156 796.584 156.416 751.945C148.415 740.785 141.732 728.658 134.171 717.235C121.246 697.815 105.86 680.68 83 669.959Z",
    fill: "url(#paint3_linear_497_4974)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.84 431.824C129.072 433.757 138.04 434.9 146.48 437.448C181.738 447.905 213.214 464.952 239.679 490.787C245.394 496.411 250.493 502.65 255.769 508.801C256.824 510.031 257.439 511.876 257.527 513.458C261.747 593.949 292.696 663.105 346.593 722.332C377.366 756.163 413.238 783.755 453.068 806.338C453.595 806.602 454.035 806.953 454.298 807.832C452.628 807.305 450.957 806.69 449.375 806.162C421.943 796.76 394.247 788.324 367.255 777.867C299.554 751.681 242.316 710.82 198.795 652.209C174.176 619.081 155.361 583.053 147.272 542.192C143.931 525.409 141.996 508.361 139.007 491.49C135.49 471.367 130.742 451.683 120.104 433.845C119.928 433.757 120.016 433.406 119.84 431.824Z",
    fill: "url(#paint4_linear_497_4974)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1068 665.385C1038.81 681.729 1021.05 707.212 1004.17 733.486C973.043 781.992 933.654 822.238 883.714 851.236C823.926 886.034 759.478 901.939 690.195 893.678C675.864 892.009 661.708 888.318 647.729 884.715C632.078 880.761 616.604 875.489 600.602 883.837C600.338 883.309 600.074 882.782 599.811 882.255C606.053 876.719 611.944 870.744 618.626 865.735C636.211 852.29 656.433 843.942 677.183 837.176C704.351 828.301 731.783 820.48 758.951 811.693C800.363 798.337 839.049 779.532 874.306 753.873C899.1 735.859 920.641 714.418 940.424 691.044C942.71 688.32 945.699 685.947 948.776 684.19C968.823 672.415 990.188 664.243 1013.22 660.991C1031.25 658.443 1049.18 659.585 1068 665.385Z",
    fill: "url(#paint5_linear_497_4974)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.79 433.227C1024.13 445.089 1018.68 455.898 1015.69 467.409C1011.47 483.753 1008.39 500.537 1005.93 517.321C1000.04 557.479 985.617 594.385 964.867 629.095C938.314 673.559 902.354 708.708 859.711 737.618C824.718 761.344 786.207 777.336 746.203 790.342C725.101 797.196 703.912 803.962 682.722 810.816C680.524 811.519 678.238 812.046 675.776 811.87C682.722 808.268 689.756 804.753 696.614 801.062C742.862 776.106 783.658 744.384 816.277 702.82C850.215 659.499 872.108 610.642 881.868 556.512C884.154 543.858 884.857 530.941 886.44 518.2C886.615 516.618 887.319 514.772 888.374 513.63C920.114 476.548 959.767 451.68 1006.63 438.323C1013.75 436.126 1021.31 434.896 1028.79 433.227Z",
    fill: "url(#paint6_linear_497_4974)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M728.178 438.587C739.081 427.691 746.01 415.917 757 405.46C771.507 391.576 790.164 379.097 804.495 365.038C812.672 356.953 819.882 347.815 827.795 338.852C829.289 342.103 830.96 345.354 832.455 348.781C847.49 381.294 858.216 415.037 862.964 450.538C875.185 542.453 850.743 623.823 792.714 695.527C767.304 726.986 735.652 751.326 701.801 772.943C699.691 774.261 697.581 775.579 695.031 776.282C696.174 775.14 697.405 774.085 698.548 772.943C736.707 734.806 763.875 690.167 775.569 637.355C790.516 570.133 779.701 507.392 738.553 450.977C737.058 448.956 735.476 447.111 733.893 445.178C732.311 443.332 730.64 441.487 728.178 438.587Z",
    fill: "url(#paint7_linear_497_4974)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_497_4974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.127 676.264C578.167 681.885 581.235 686.267 583.092 691.26C585.241 697.008 582.654 702.849 577.748 705.683C572.009 708.982 565.151 708.449 560.941 704.292C557.536 700.908 556.193 696.873 557.765 692.146C558.286 690.499 558.932 688.804 559.714 687.273C563.799 678.758 563.662 677.654 557.075 671.089C549.994 663.993 548.621 652.958 553.878 644.857C559.503 636.397 570.317 632.945 579.882 636.553C588.536 639.862 594.207 649.672 592.565 659.269C591.221 667.016 586.696 672.521 579.272 675.387C577.975 675.96 576.396 675.991 575.127 676.264Z",
    fill: "url(#paint8_linear_497_4974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.578 707.889C573.592 703.94 577.085 701.285 581.605 700.264C594.002 697.541 603.659 706.868 601.673 719.667C600.851 724.773 598.796 729.403 595.44 733.42C588.659 741.521 580.304 747.785 571.605 753.572C570.92 754.048 569.277 754.117 568.66 753.64C560.03 747.376 551.264 741.181 544.689 732.603C541.196 728.109 539.072 723.003 539.004 717.284C538.867 709.591 542.36 703.668 548.593 701.149C555.305 698.358 562.839 699.924 568.112 705.234C568.797 705.983 569.551 706.8 570.578 707.889Z",
    fill: "url(#paint9_linear_497_4974)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 674,
    cy: 100.876,
    rx: 5,
    ry: 4.99317,
    fill: "#FFAE00",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_497_4974",
    x: 430.397,
    y: 0,
    width: 331.736,
    height: 754.031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_497_4974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_497_4974",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_497_4974",
    x: 430.026,
    y: 560.441,
    width: 277.396,
    height: 336.74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_497_4974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_497_4974",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_497_4974",
    x: 534,
    y: 630.135,
    width: 72.9326,
    height: 128.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_497_4974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_497_4974",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_497_4974",
    x1: 596.266,
    y1: 0,
    x2: 596.266,
    y2: 744.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_497_4974",
    x1: 568.724,
    y1: 560.441,
    x2: 568.724,
    y2: 887.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_497_4974",
    x1: 364.266,
    y1: 335.688,
    x2: 364.266,
    y2: 777.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_497_4974",
    x1: 310.105,
    y1: 663.012,
    x2: 310.105,
    y2: 893.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_497_4974",
    x1: 287.069,
    y1: 431.824,
    x2: 287.069,
    y2: 807.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_497_4974",
    x1: 833.905,
    y1: 659.709,
    x2: 833.905,
    y2: 895.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_497_4974",
    x1: 852.282,
    y1: 433.227,
    x2: 852.282,
    y2: 811.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_497_4974",
    x1: 780.532,
    y1: 338.852,
    x2: 780.532,
    y2: 776.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_497_4974",
    x1: 583.448,
    y1: 638.106,
    x2: 554.953,
    y2: 702.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05364C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_497_4974",
    x1: 570.466,
    y1: 699.787,
    x2: 570.466,
    y2: 753.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/LOGO.80f051723dfa8ea598908a4d6cde4b59.svg";
export { ForwardRef as ReactComponent };